module.exports = __webpack_public_path__ + "static/media/3DPPA44.fdae219d.jpg";